// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/select/Primary.story.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { Select } from '@sail/ui';
export const Primary = () => <Select name="demo-001" label="Choose a pet" onChange={e => {
  // eslint-disable-next-line no-console
  console.log(e);
}}>
    <option value="">Choose an option</option>
    <option value="dogs">Dogs</option>
    <option value="cats">Cats</option>
  </Select>;